import "../../../css/DesignSystem/Buttons/StatusButton.css";

const StatusButton = ({ type, color }) => {
  return (
      <div className={`Status-Button-Container ${color}`}>
          <div className="Status-Indicator" />
      <div className="FP_Content">{type}</div>
    </div>
  );
};

export default StatusButton;
